import React, { useMemo } from "react";
import { Modal, Table } from "react-bootstrap";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { buildPermissionMatrix } from "./roleHelper";

const PermissionsModal = ({ show, onHide, role }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { columns, rows } = useMemo(
    () => buildPermissionMatrix(role?.permissions, language),
    [role, language],
  );

  const roleName = language === "ar" ? role?.nameAr || role?.name : role?.name;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable
      className="permissions_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("Permissions")}
          {roleName && <span className="role_name"> — {roleName}</span>}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {rows.length === 0 ? (
          <p className="text-muted mb-0 text-center">{t("No permissions")}</p>
        ) : (
          <div className="table-responsive">
            <Table bordered hover className="permissions_matrix mb-0">
              <thead>
                <tr>
                  <th>{t("Module Name")}</th>
                  {columns.map((col) => (
                    <th key={col.key} className="text-center">
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.module}>
                    <td className="module_name">{row.label}</td>
                    {columns.map((col) => {
                      const allowed = row.granted.has(col.key);
                      return (
                        <td key={col.key} className="text-center">
                          {allowed ? (
                            <Check
                              size={18}
                              className="perm_icon allowed"
                              aria-label={t("Yes")}
                            />
                          ) : (
                            <X
                              size={18}
                              className="perm_icon denied"
                              aria-label={t("No")}
                            />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PermissionsModal;
